import React from 'react';

const SearchResult = (props) => (
    <div className="searchResult">
        <h3>Hit the play button and enjoy the preview of your favourite track</h3>
    </div>
);

export default SearchResult;